// src/pages/Register/Register.jsx
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";
import RecaptchaField from "../../components/RecaptchaField/RecaptchaField";
import { toast } from "react-toastify";
import axios from "axios";
import { MdArrowBack } from "react-icons/md";

import GoogleLoginButton from "../../components/GoogleLoginButton/GoogleLoginButton";


export default function Register() {
  const formRef = useRef();
  const recaptchaRef = useRef();
  const recaptchaValue = useRef(null);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!recaptchaValue.current) {
      toast.error("Vahvista reCAPTCHA ennen rekisteröintiä.");
      return;
    }

    const formData = new FormData(formRef.current);
    const payload = {
      name: formData.get("name"),
      email: formData.get("email"),
      password: formData.get("password"),
    };

    try {
      const response = await axios.post("/api/register_user.php", payload);
      if (response.data.success) {
        toast.success("Rekisteröityminen onnistui! Kirjaudutaan sisään...");
        // Tallennetaan token ja siirrytään eteenpäin
        localStorage.setItem("token", response.data.token);
        setTimeout(() => {
          navigate("/choose-profile"); // Tästä voidaan tehdä valinta: vuokraaja vai esiintyjä
        }, 1500);
      } else {
        toast.error(response.data.message || "Rekisteröinti epäonnistui.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Palvelinvirhe. Yritä hetken päästä uudelleen.");
    }
  };

  return (
    <div className="pt-24 pb-12 px-4 dark:bg-purple-950 text-darkest dark:text-primary dark:bg-opacity-75">
      <Helmet>
        <title>Spiderlegs Productions | Rekisteröidy</title>
        <meta name="description" content="Luo oma Spiderlegs-tilisi ja pääse varaamaan laitteita tai liittymään esiintyjäverkostoon." />
      </Helmet>

      <ResponsiveButton
        onClick={() => {
          if (window.history.length > 2) {
            navigate(-1);
          } else {
            navigate("/");
          }
          setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
        }}
        variant="backbutton"
        className="ml-4"
      >
        <div className="flex items-center gap-2">
          <MdArrowBack className="text-xl" />
          <span>Takaisin</span>
        </div>
      </ResponsiveButton>

      <h1 className="font-customFont2 text-center text-5xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 pt-8 dark:text-shadow-xxl">
        Luo oma tili
      </h1>

      <p className="max-w-3xl mx-auto mb-8 font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary font-normal text-lg">
  Kirjaudu sisään Google-tilillä tai luo oma tili sähköpostilla. Tilin luonnin jälkeen valitset, haluatko käyttää palvelua vuokraajana vai esiintyjänä!
</p>


      <motion.form
        ref={formRef}
        onSubmit={handleRegister}
        className="max-w-2xl mx-auto p-8 bg-primary bg-opacity-75 dark:bg-violet dark:bg-opacity-75 rounded-3xl shadow-xl space-y-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >

<GoogleLoginButton />

        {/* Nimi */}
        <div>
          <label htmlFor="name" className="block font-customFont1 text-lg mb-2">Nimesi *</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            placeholder="Nimesi..."
            className="w-full p-3 rounded-full bg-white dark:bg-darkest border-none focus:outline-none text-lg pl-5"
          />
        </div>

        {/* Sähköposti */}
        <div>
          <label htmlFor="email" className="block font-customFont1 text-lg mb-2">Sähköposti *</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            placeholder="Sähköpostiosoite..."
            className="w-full p-3 rounded-full bg-white dark:bg-darkest border-none focus:outline-none text-lg pl-5"
          />
        </div>

        {/* Salasana */}
        <div>
          <label htmlFor="password" className="block font-customFont1 text-lg mb-2">Salasana *</label>
          <input
            type="password"
            id="password"
            name="password"
            required
            placeholder="Vähintään 6 merkkiä..."
            className="w-full p-3 rounded-full bg-white dark:bg-darkest border-none focus:outline-none text-lg pl-5"
          />
        </div>

        {/* reCAPTCHA */}
        <div className="my-4 scale-[0.85] origin-left">
          <RecaptchaField
            siteKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={(value) => (recaptchaValue.current = value)}
            innerRef={recaptchaRef}
          />
        </div>

        {/* Lähetä */}
        <div className="flex justify-center">
          <ResponsiveButton type="submit" className="w-full max-w-xs rounded-full">
            Rekisteröidy
          </ResponsiveButton>
        </div>
      </motion.form>
        

    </div>
  );
}
